import { render, staticRenderFns } from "./airClean.vue?vue&type=template&id=bcf8db06&scoped=true"
import script from "./airClean.vue?vue&type=script&lang=js"
export * from "./airClean.vue?vue&type=script&lang=js"
import style0 from "./airClean.vue?vue&type=style&index=0&id=bcf8db06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf8db06",
  null
  
)

export default component.exports